import { render, staticRenderFns } from "./AccountingWallet.vue?vue&type=template&id=7ebfb056&scoped=true&"
import script from "./AccountingWallet.vue?vue&type=script&lang=js&"
export * from "./AccountingWallet.vue?vue&type=script&lang=js&"
import style0 from "./AccountingWallet.vue?vue&type=style&index=0&id=7ebfb056&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebfb056",
  null
  
)

export default component.exports